import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=57c9c2f5"
import script from "./Bookmarks.vue?vue&type=script&lang=js"
export * from "./Bookmarks.vue?vue&type=script&lang=js"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=57c9c2f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports